import React from 'react';

import useResourceOnboardingSequence from '../../hooks/useResourceOnboardingSequence';
import { ResourceOnboardingSequenceButton } from './styled';

interface ResourceOnboardingSequenceCloseProps {
  style?: React.CSSProperties;
}

export default function ResourceOnboardingSequenceClose({
  style,
}: ResourceOnboardingSequenceCloseProps) {
  const { close } = useResourceOnboardingSequence();

  const handleClick = () => {
    close();
  };

  return (
    <ResourceOnboardingSequenceButton onClick={handleClick} style={style}>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ zIndex: 1, position: 'relative' }}
      >
        <g filter="url(#filter0_b_41480_3825)">
          <circle cx="12" cy="12.5234" r="9" fill="#EB823D" fillOpacity="0.3" />
          <circle cx="12" cy="12.5234" r="10" stroke="#FFA366" strokeWidth="2" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5359 16.0593C15.9265 15.6687 15.9265 15.0356 15.5359 14.6451L13.4146 12.5237L15.5358 10.4024C15.9264 10.0119 15.9264 9.37875 15.5358 8.98823C15.1453 8.5977 14.5121 8.59771 14.1216 8.98823L12.0004 11.1095L9.87907 8.98821C9.48855 8.59768 8.85539 8.59768 8.46486 8.98821C8.07434 9.37873 8.07434 10.0119 8.46486 10.4024L10.5861 12.5237L8.46477 14.6451C8.07424 15.0356 8.07424 15.6688 8.46477 16.0593C8.85529 16.4498 9.48846 16.4498 9.87898 16.0593L12.0004 13.9379L14.1217 16.0593C14.5122 16.4498 15.1454 16.4498 15.5359 16.0593Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_b_41480_3825"
            x="-47"
            y="-46.4766"
            width="118"
            height="118"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="24" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_41480_3825"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_41480_3825"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </ResourceOnboardingSequenceButton>
  );
}
